import { call, put, takeLatest } from "redux-saga/effects";
import * as settingsApis from "../apis/settingsApi"
import { RESET_PASSWORD, SAVE_SETTINGS, UPLOAD_LOGO, VIEW_SETTINGS } from "../actions/types";
import { COMPANY_DATA_FAILED, COMPANY_DATA_LOADED } from "../actions/returnType";


export function* saveSettingsWorker(action) {
    try {
        const res = yield call(settingsApis.saveSettingsApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* viewSettingsWorker(action) {
    try {
        const res = yield call(settingsApis.viewSettingsApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
            yield put({ type: COMPANY_DATA_LOADED, data: res?.data?.data?.company });
        } else {
            yield action.onError(res);
            yield put({
                type: COMPANY_DATA_FAILED,
                data: res?.data,
            });
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* resetPasswordWorker(action) {
    try {
        const res = yield call(settingsApis.resetPasswordApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* uploadLogoWorker(action) {
    try {
        const file = new FormData();
        file.append("file", action.file);
        const res = yield call(settingsApis.uploadLogoApi, file);

        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* viewSettingsWatcher() {
    yield takeLatest(VIEW_SETTINGS, viewSettingsWorker);
}
export function* uploadLogoWatcher() {
    yield takeLatest(UPLOAD_LOGO, uploadLogoWorker);
}
export function* saveSettingsWatcher() {
    yield takeLatest(SAVE_SETTINGS, saveSettingsWorker);
}
export function* resetPasswordWatcher() {
    yield takeLatest(RESET_PASSWORD, resetPasswordWorker);
}